import { useTranslation } from '@kc-console/core';
import { LogoKakaoCloudRegular } from '@kep/kcds-icons';

import PreviousPageButton from '../components/PreviousPageButton';
import FullWidthErrorTemplate from '../FullWidthErrorTemplate';

import type { ReactNode } from 'react';
import type { BaseErrorPageProps } from '../types';

export interface NotFoundProps extends BaseErrorPageProps {}

/**
 * 404 페이지를 찾을 수 없음 컴포넌트
 *
 * @description
 * FullWidthErrorTemplate을 사용하여 404 Not Found 페이지를 렌더링합니다.
 * "이전 페이지로 이동" 버튼이 표시됩니다.
 */
export default function NotFound({ description, templateProps }: NotFoundProps): ReactNode {
  const { t } = useTranslation();

  const defaultDescription = (
    <>
      {t('ui:error_page.not_found.reason')}
      {'\n'}
      {t('ui:error_page.not_found.instruction')}
    </>
  );

  return (
    <FullWidthErrorTemplate
      {...templateProps}
      logo={<LogoKakaoCloudRegular />}
      title={t('ui:error_page.not_found.title')}
      description={description ?? defaultDescription}
      actions={<PreviousPageButton fullReloadOnRoute />}
      containerWidth="475px"
    />
  );
}
